/**
 * Renders the global playbar
 */

import React from 'react';

// Helpers
import { parseSeconds } from '../../../helpers/helpers';

// Components
import * as icons from '../../ui/Icons';
import ProgressBar from './ProgressBar';

class Playbar extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      flags: [],
      highlights: []
    };
  }

  componentDidMount() {
    const { prepareFlags, prepareHighlights, richPlaybar, session } = this.props;

    // Set up progress bar highlight areas and flags
    if (richPlaybar) {
      const { annotations } = session.automated;

      prepareFlags(annotations, this);
      prepareHighlights(annotations, this);
    }
  }

  render() {
    const speeds = [.25, .5, 1, 2, 3, 6, 10, 16];
    const { flags, highlights } = this.state;
    const {
      complete,
      current,
      duration,
      isFullScreen,
      isMuted,
      isPlaying,
      onFullScreen,
      onMute,
      onPlay,
      onPlaySpeed,
      onReplay,
      onSeek,
      onVolume,
      translation,
      volume
    } = this.props;

    return (
      <section className="playbar">
        <h2 className="meta">{translation.heading}</h2>

        <div className="playbar__controls">
          {/* Play/pause button */}
          {!complete &&
            <button
              className="playbar__play playbar__btn"
              type="button"
              onClick={onPlay}
              title={isPlaying ? translation.pause : translation.play}
            >
              {isPlaying ? <icons.pause /> : <icons.play />}

              <span className="meta">
                {isPlaying ? translation.pause : translation.play}
              </span>
            </button>
          }

          {/* Replay button */}
          {complete &&
            <button
              className="playbar__play playbar__btn"
              type="button"
              onClick={onReplay}
              title={isPlaying ? translation.pause : translation.play}
            >
              <icons.redo />

              <span className="meta">
                {isPlaying ? translation.pause : translation.play}
              </span>
            </button>
          }

          {/* Playback speed button */}
          <select
            aria-labelledby="speed-select"
            className="playbar__speed"
            defaultValue={1}
            onChange={onPlaySpeed}
            title={translation.speed} 
          >
            {speeds.map((el, i) => {
              return (
                <option key={i} value={el}>{el}x</option>
              )
            })}
          </select>
          <span className="meta" id="speed-select">{translation.speed}</span>
        </div>

        <ProgressBar
          {...this.props}
          className="playbar__progress"
          current={current}
          duration={duration}
          onPlay={onPlay}
          onSeek={onSeek}
          flags={flags}
          highlights={highlights}
        />

        <span className="playbar__time">
          {parseSeconds(current)}/{parseSeconds(duration)}
        </span>

        <div className="playbar__controls">
          {/* Volume button */}
          <button
            className="playbar__mute playbar__btn"
            type="button"
            onClick={onMute}
            title={isMuted ? translation.unmute : translation.mute}
          >
            {isMuted &&
              <icons.speakerOff />
            }

            {!isMuted && parseFloat(volume) < .5 &&
              <icons.speakerOnHalf />
            }

            {!isMuted && parseFloat(volume) >= .5 &&
              <icons.speakerOn />
            }

            <span className="meta">
              {isMuted ? translation.unmute : translation.mute}
            </span>
          </button>

          {/* Volume slider */}
          <div className="playbar__volume">
            <input
              className="volume"
              type="range"
              min="0"
              max="1"
              step=".01"
              value={volume}
              onChange={(e) => onVolume(e.target.value)}
            />
          </div>
        </div>

        <div className="playbar__controls">
          {/* Full screen button */}
          <button
            className="playbar__full-screen playbar__btn"
            type="button"
            onClick={onFullScreen}
            title={isFullScreen ? translation.unfullScreen : translation.fullScreen}
          >
            {isFullScreen ? <icons.unFullScreen /> : <icons.fullScreen />}

            <span className="meta">
              {isFullScreen ? translation.unfullScreen : translation.fullScreen}
            </span>
          </button>
        </div>
      </section>
    )
  }
};

export default Playbar;
